import axios from 'axios'

import environment from '@/environment'
import type { AggregateMarket, AggregateSuggestedBidResponse } from '@/features/bidding/types/aggregateSuggestedBid'

const PORTFOLIO_MANAGER_API_URL = environment.services.portfolioManagerApiUrl

export const GET_AGGREGATE_SUGGESTED_BIDS_API_ID = 'GET_AGGREGATE_SUGGESTED_BIDS'

export type GetAggregateSuggestedBidsParams = {
  portfolioCode: string
  market: AggregateMarket
  deliveryDay: string
  resourceCategory: string
}

export const getAggregateSuggestedBids = async (
  params: GetAggregateSuggestedBidsParams,
): Promise<AggregateSuggestedBidResponse> =>
  (await axios.get(`${PORTFOLIO_MANAGER_API_URL}/aggregate-bidding/suggested-bids`, { params })).data
